/**
 * @fileoverview Renderers for the Form component in the Storyteller application.
 * Contains renderers for various form elements and their corresponding testers.
 *
 * @example
 * // Usage in a component:
 * import { renderers } from './renderers'
 *
 * <Form renderers={renderers} />
 */

import { horizontalLayoutTester, labelRendererTester } from '@jsonforms/vanilla-renderers'

import AudioStreamerRenderer, { AudioStreamerTester } from './renderers/AudioStreamerRenderer'
import BrowserInstructionsRenderer, {
    BrowserInstructionsTester,
} from './renderers/BrowserInstructionsRenderer'
import CaptionRenderer, { CaptionTester } from './renderers/CaptionRenderer'
import CheckboxGroupRenderer, { CheckboxGroupTester } from './renderers/CheckboxGroupRenderer'
import ChoiceQuestionRenderer, { ChoiceQuestionTester } from './renderers/ChoiceQuestionRenderer'
import CommentRenderer, { CommentTester } from './renderers/CommentRenderer'
import CSATRenderer, { CSATTester } from './renderers/CSATRenderer'
import DateRenderer, { DateTester } from './renderers/DateRenderer'
import DropdownRenderer, { DropdownTester } from './renderers/DropdownRenderer'
import GroupRenderer, { GroupTester } from './renderers/GroupRenderer'
import HorizontalLayoutRenderer from './renderers/HorizontalLayoutRenderer'
import ICFRenderer, { ICFTester } from './renderers/ICFRenderer'
import IconRenderer, { IconTester } from './renderers/IconRenderer'
import InputRenderer, { InputTester } from './renderers/InputRenderer'
import InstructionRenderer, { InstructionTester } from './renderers/InstructionRenderer'
import LabelRenderer from './renderers/LabelRenderer'
import ListRenderer, { ListTester } from './renderers/ListRenderer'
import LocationInputRenderer, { LocationInputTester } from './renderers/LocationInputRenderer'
import MicrophoneCheckRenderer, { MicrophoneCheckTester } from './renderers/MicrophoneCheck'
import NativeDropdownRenderer, { NativeDropdownTester } from './renderers/NativeDropdownRenderer'
import NoteRenderer, { NoteTester } from './renderers/NoteRenderer'
import NumberedListRenderer, { NumberedListTester } from './renderers/NumberedListRenderer'
import PhoneInputRenderer, { PhoneInputTester } from './renderers/PhoneInputRenderer'
import PhoneValidationRenderer, { PhoneValidationTester } from './renderers/PhoneValidationRenderer'
import RadioGroupRenderer, { RadioGroupTester } from './renderers/RadioGroupRenderer'
import ResendPhoneVerificationRenderer, {
    ResendPhoneVerificationTester,
} from './renderers/ResendPhoneVerificationRenderer'
import SoundCheckRenderer, { SoundCheckTester } from './renderers/SoundCheckRenderer'
import SpacerRenderer, { SpacerTester } from './renderers/SpacerRenderer'
import SubmitLinkRenderer, { SubmitLinkTester } from './renderers/SubmitLinkRenderer'
import TextRenderer, { TextTester } from './renderers/TextRenderer'

export const renderers = [
    {
        tester: InputTester,
        renderer: InputRenderer,
    },
    {
        tester: DropdownTester,
        renderer: DropdownRenderer,
    },
    {
        tester: NativeDropdownTester,
        renderer: NativeDropdownRenderer,
    },
    {
        tester: GroupTester,
        renderer: GroupRenderer,
    },
    {
        tester: IconTester,
        renderer: IconRenderer,
    },
    {
        tester: horizontalLayoutTester,
        renderer: HorizontalLayoutRenderer,
    },
    {
        tester: labelRendererTester,
        renderer: LabelRenderer,
    },
    {
        tester: CommentTester,
        renderer: CommentRenderer,
    },
    {
        tester: NumberedListTester,
        renderer: NumberedListRenderer,
    },
    {
        tester: NoteTester,
        renderer: NoteRenderer,
    },
    {
        tester: CaptionTester,
        renderer: CaptionRenderer,
    },
    {
        tester: TextTester,
        renderer: TextRenderer,
    },
    {
        tester: ICFTester,
        renderer: ICFRenderer,
    },
    {
        tester: CheckboxGroupTester,
        renderer: CheckboxGroupRenderer,
    },
    {
        tester: RadioGroupTester,
        renderer: RadioGroupRenderer,
    },
    {
        tester: DateTester,
        renderer: DateRenderer,
    },
    {
        tester: LocationInputTester,
        renderer: LocationInputRenderer,
    },
    {
        tester: PhoneInputTester,
        renderer: PhoneInputRenderer,
    },
    {
        tester: PhoneValidationTester,
        renderer: PhoneValidationRenderer,
    },
    {
        tester: ResendPhoneVerificationTester,
        renderer: ResendPhoneVerificationRenderer,
    },
    {
        tester: SubmitLinkTester,
        renderer: SubmitLinkRenderer,
    },
    {
        tester: CSATTester,
        renderer: CSATRenderer,
    },
    {
        tester: SoundCheckTester,
        renderer: SoundCheckRenderer,
    },
    {
        tester: InstructionTester,
        renderer: InstructionRenderer,
    },
    {
        tester: ListTester,
        renderer: ListRenderer,
    },
    {
        tester: BrowserInstructionsTester,
        renderer: BrowserInstructionsRenderer,
    },
    {
        tester: MicrophoneCheckTester,
        renderer: MicrophoneCheckRenderer,
    },
    {
        tester: AudioStreamerTester,
        renderer: AudioStreamerRenderer,
    },
    {
        tester: ChoiceQuestionTester,
        renderer: ChoiceQuestionRenderer,
    },
    {
        tester: SpacerTester,
        renderer: SpacerRenderer,
    },
]
